import styled, { css } from "styled-components";

const ButtonContent = styled.span`
  display: flex;
  align-items: center;
`;

const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  margin-right: 0.5em; // Adjust spacing between icon and text
`;

const sizes = {
  small: css`
    font-size: 1.2rem;
    padding: 0.4rem 0.8rem;
    text-transform: uppercase;
    font-weight: 600;
    text-align: center;
  `,
  medium: css`
    margin-top: 1rem;
    font-size: 1.4rem;
    padding: 1.2rem 1.6rem;
    font-weight: 500;
  `,
  large: css`
    font-size: 1.6rem;
    padding: 1.2rem 2.4rem;
    font-weight: 500;
  `,
};

const variations = {
  primary: css`
    color: var(--color-brand-50);
    background-color: var(--color-brand-600);

    &:hover {
      background-color: var(--color-brand-700);
    }
  `,
  secondary: css`
    color: var(--color-grey-600);
    background: var(--color-grey-0);
    border: 1px solid var(--color-grey-200);

    &:hover {
      background-color: var(--color-grey-50);
    }
  `,
  danger: css`
    color: var(--color-red-100);
    background-color: var(--color-red-700);

    &:hover {
      background-color: var(--color-red-800);
    }
  `,
};

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--color-grey-900);
  padding: 0.7em 1.7em;
  font-size: 1em;
  width: auto;
  margin-left: 0.5em;
  white-space: nowrap;
  border-radius: 0.5em;
  background: var(--color-grey-0);
  border: 1px solid var(--color-grey-100);
  transition: all 0.3s;
  box-shadow: var(--shadow-btn);

  ${(props) => sizes[props.$size]}
  ${(props) => variations[props.$variation]}

  &:active {
    color: var(--color-grey-300);
    box-shadow: var(--shadow-btn-active);
  }
`;

const ButtonNeu = ({ icon, children, ...props }) => {
  return (
    <Button {...props}>
      <ButtonContent>
        {icon && <IconWrapper>{icon}</IconWrapper>}
        {children}
      </ButtonContent>
    </Button>
  );
};

export default ButtonNeu;
